import React, { createContext } from "react";
import { Link } from "react-router-dom";

import "./About.css";
import png from "../../images/About.png";

function About() {
  return (
    <div className="about">
      <div className="about__title">
        <div className="about__title-text">
          О КОМПАНИИ
        </div>
        {/* <div className="about__button1">
          <button> Больше </button>
        </div> */}
      </div>
      <div className="about__text-container">
        <img src={png} className="about__img1" align="left"/>
        <div className="about__text-title">
          Компания ООО "ДКМ Системы" основана в декабре 2023 года командой инженеров-единомышленников,
          объединённых одной целью: разработка и изготовление технологического оборудования высочайшего уровня и
          качества в соответствии с современными тенденциями развития машиностроительной отрасли.
        </div>
        <img src={png} className="about__img2" align="left"/>
        <div className="about__text-body">
          Главным направлением развития компании является насосное оборудование для водного хозяйства.
          Учитывая сложные современные тенденции на рынке, мы понимаем необходимость развития компании
          ООО "ДКМ Системы" в сторону предложения оборудования, произведённого в России, при этом не
          уступающего по качеству изготовления, обслуживания крупным именитым мировым брендам.
          Мы уверены в наших приоритетах развития и сделаем всё возможное для становления компании на серьёзном уровне.
        </div>
        {/* <div className="about__button2">
          <button> Больше о компании </button>
        </div> */}
      </div>
    </div>
  );
}

export default About;
